import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem("SessionUserId");

  useEffect(() => {
  if (!token) {
    window.location.replace(process.env.REACT_APP_ADMIN_REDIRECT);
  }
}, [token]);

  if (!token) {
    return null;
  }

  return children;
};

export default PrivateRoute;